import {FC, useContext, useEffect, useMemo} from 'react';
import {useRecoilValue, useRecoilValueLoadable} from 'recoil';

import Fallback from '../../ui/fallback/Fallback';
import NavCards from '../../ui/nav-cards/NavCards';

import {EventBusContext} from '../../providers/EventBus';

import {reportsQuery} from '../../store/reports/selectors';

import {IMenuItemDynamicLink} from '../../shared/types/menu.types';

import styles from './Reports.module.scss';
import {authState} from '../../store/auth/atoms';
import {TypeAccountRoles} from '../../shared/types/user-account.types';

const ReportsPage: FC = () => {
  const {user} = useRecoilValue(authState);
  const {bus} = useContext(EventBusContext);

  const isCustomer = user?.roles?.filter((i) => i !== TypeAccountRoles.CUSTOMER).length === 1;

  return (
    <div className={styles.reports}>
      <div className={styles.navCards}>
        <NavCards
          variant="grid"
          menu={[
            {link: `/reports/executed`, title: 'Отчет по заявкам'},
            {link: `/reports/universal`, title: 'Универсальный отчет'},
            {link: `/reports/forma`, title: 'Форма выработки перечней'},
            ...(isCustomer ? [] : [{link: `/reports/delay`, title: 'Реестр актов недопуска'}]),
            ...(isCustomer ? [] : [{link: `/reports/masterCounter`, title: 'Отчет по мастер счетчикам'}]),
          ]}
          sxTitle={{fontSize: '13px'}}
        />
      </div>
    </div>
  );
};

export default ReportsPage;
